import PropTypes from 'prop-types';
import React from 'react';
import Modal from 'components/Modal/Modal';

import ButtonWithLoader from 'components/ButtonWithLoader/ButtonWithLoader';

import styles from './ReopenJobModal.module.scss';

const ReopenJobModal = ({ show, onCancel, onConfirm, isReopening }) => {
  return (
    <Modal closeButton show={show} title="Re-open Job" onExit={onCancel}>
      <div className={styles.modalContent}>
        <p className={styles.modalText}>
          Are you sure you want to re-open this job? This will allow new
          applicants to apply.
        </p>
        <div className={styles.modalActions}>
          <ButtonWithLoader
            bsStyle="default"
            onClick={onCancel}
            disabled={isReopening}
            loading={false}
            text="Cancel"
          />
          <ButtonWithLoader
            bsStyle="primary"
            onClick={onConfirm}
            disabled={isReopening}
            loading={isReopening}
            text="Re-open Job"
          />
        </div>
      </div>
    </Modal>
  );
};

ReopenJobModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  isReopening: PropTypes.bool.isRequired,
};

export default ReopenJobModal;
